import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../../components/Button';
import messages from '../../messages';
import { DynamicDatePicker } from './DynamicDatePicker';
import PageSectionHeader from '../../../components/PageSectionHeader'

export class DynamicDatePickerList extends React.Component {
  componentDidMount() {
    if (this.props.data.length <= 0) {
      this.addItem();
    }
  }

  onRemove = (id) => {
    let arrayData = this.props.data;

    // find and remove item from data by id
    arrayData = arrayData.filter((t) => t.id !== id);

    this.onChange(arrayData);
  };

  onItemChanged = (itemChanged) => {
    const item = this.props.data.filter((t) => t.id === itemChanged.id)[0];

    if (item) {
      // find and update item by id
      const newData = this.props.data.map(
        (el) =>
          el.id === itemChanged.id ? Object.assign({}, el, itemChanged) : el
      );

      this.onChange(newData);
    }
  };

  onChange = (data) => {
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  };

  addItem = () => {
    const arrayData = this.props.data;

    arrayData.push({
      id: new Date().getTime().toString(),
      dateSelected: '',
    });

    this.onChange(arrayData);
  };

  render() {
    const { data } = this.props;
    const { disabled } = this.props;
    const removable = data.length > 1;
    return (
      <div>
        {!disabled && (
          <div className="row">
            <div className='col-2 mt-1'>
                <PageSectionHeader>
                    <FormattedMessage {...messages.treatmentDates} />
                </PageSectionHeader>
            </div>
            <div className="col-2 ml-1">
              <Button onClick={this.addItem}>
                <FormattedMessage {...messages.addDate} />
              </Button>
            </div>
          </div>
        )}
        
          {data.map((item, index) => (
            <DynamicDatePicker
              {...this.props}
              index={index}
              key={item.id}
              item={item}
              onChange={this.onItemChanged}
              onRemove={this.onRemove}
              disabled={disabled}
              removable={removable}
            />
          ))}
        
      </div>
    );
  }
}

DynamicDatePickerList.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  isDelayed: PropTypes.bool,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/components/DynamicDatePicker/index.js